module.exports = __webpack_public_path__ + "img/PCT12.4abd19f0.svg";